module.exports = __webpack_public_path__ + "img/gift_icon.96819fc2.svg";